import { mfaSettingsStateModel } from './stateModels';

export function mfaSettings(state = mfaSettingsStateModel, action) {
    switch (action.type) {
        default:
            return state
    }
}